import React from 'react';
import { Box, Container, Grid, Typography, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { ShieldCheck } from 'lucide-react';
import { useSelector } from 'react-redux';
import packageJson from '../../../../../package.json';

export default function Footer() {
    const currentYear = new Date().getFullYear();
    const authData = useSelector((s) => s.auth.data);

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #E2E8F0',
                py: 3,
                mt: 'auto',
            }}
        >
            <Container maxWidth="xl">
                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                    {/* Left: Dopasi Foundation & Copyright */}
                    <Grid item xs={12} md={5} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-2 mb-1">
                            <span style={{ fontWeight: 700, color: '#8B0304', fontSize: '0.95rem' }}>
                                eRespiroConnect
                            </span>
                            <span
                                style={{
                                    fontSize: '0.72rem',
                                    fontWeight: 600,
                                    color: '#64748B',
                                    backgroundColor: '#F1F5F9',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '9999px',
                                    padding: '1px 7px',
                                    lineHeight: '1.4',
                                }}
                            >
                                v{packageJson.version}
                            </span>
                            <span className="text-muted" style={{ fontSize: '0.8rem' }}>
                                • Health Data & Surveillance System
                            </span>
                        </div>
                        <Typography variant="body2" sx={{ color: '#64748B', fontSize: '0.8rem' }}>
                            Copyright © {currentYear} Dopasi Foundation. All rights reserved. TB REACH Wave 11.
                        </Typography>
                    </Grid>

                    {/* Center: Social Links */}
                    <Grid
                        item
                        xs={12}
                        md={3}
                        sx={{
                            textAlign: 'center',
                        }}
                    >
                        <IconButton
                            size="small"
                            target="_blank"
                            href="https://www.facebook.com/dopasigroup"
                            aria-label="Facebook"
                            sx={{ color: '#64748B', '&:hover': { color: '#B11116' }, mx: 0.5 }}
                        >
                            <FacebookIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            target="_blank"
                            href="https://x.com/Dopasifoundaton"
                            aria-label="Twitter"
                            sx={{ color: '#64748B', '&:hover': { color: '#B11116' }, mx: 0.5 }}
                        >
                            <TwitterIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            target="_blank"
                            href="https://www.instagram.com/dopasi_foundation"
                            aria-label="Instagram"
                            sx={{ color: '#64748B', '&:hover': { color: '#B11116' }, mx: 0.5 }}
                        >
                            <InstagramIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            target="_blank"
                            href="https://www.linkedin.com/company/dopasi-foundation/"
                            aria-label="LinkedIn"
                            sx={{ color: '#64748B', '&:hover': { color: '#B11116' }, mx: 0.5 }}
                        >
                            <LinkedInIcon fontSize="small" />
                        </IconButton>
                    </Grid>

                    {/* Right: Quick Links */}
                    <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'right' } }}>
                        <div className="d-flex align-items-center justify-content-center justify-content-md-end gap-3" style={{ fontSize: '0.8rem' }}>
                            <Link to={authData && authData?.id ? "/portal/privacy-policy" : "/privacy-policy"} className="text-secondary text-decoration-none hover-primary">
                                Privacy Policy
                            </Link>
                            <span className="text-muted">•</span>
                            <a href="https://dopasi.org" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none hover-primary">
                                Dopasi Foundation
                            </a>
                            <span className="text-muted">•</span>
                            <span className="d-inline-flex align-items-center gap-1 text-success fw-semibold">
                                <ShieldCheck size={14} /> Encrypted
                            </span>
                            <span className="text-muted">•</span>
                            <span className="text-muted fw-semibold font-monospace" style={{ fontSize: '0.75rem' }}>
                                v{packageJson.version}
                            </span>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
